import { get } from 'lodash';
import { ALL_FILTER, TEAM_FILTER } from './constants';
import { cardTypes } from '../components/Metrics/cardTypes';
import { filterIds, reportGroup as groups, reportViews as views } from './filters';
import { ENTITY_NAMES } from '../api/requests/entityNames';
import { type UserInterface } from './types';

const setFilter = (view: string, subvalues: any[], group: string) => {
    return {
        [filterIds.reportViewFilter]: {
            value: view,
            subvalues
        },
        [filterIds.reportTabGroupFilter]: group
    };
};

const selectTeamIds = (entities: any) => {
    return get(entities, ENTITY_NAMES.TEAMS, []).map((team: any) => team.id);
};

export const setReportViewFilterFromDashboard = (
    state: any,
    cardId: string,
    user: UserInterface,
    dashboardSelections: any,
    entities: any
) => {
    // console.log('setReportViewFilterFromDashboard', cardId, user, entities);

    const filter = get(state, `cards.${cardId}`, {});
    switch (cardId) {
        case cardTypes.agenciesWords:
            return setFilter(views.all, [], groups.agencies);
        case cardTypes.locationWords:
            if (filter.agency === ALL_FILTER) {
                return setFilter(views.all, [], groups.locations);
            }
            return setFilter(views.agencies, [filter.agency], groups.locations);
        case cardTypes.overviewAgencyWords:
            return setFilter(views.agencies, [user.agencyId], groups.agencies);
        case cardTypes.agencyLocationsWords:
            return setFilter(views.agencies, [user.agencyId], groups.locations);
        case cardTypes.agencyAgentsWords:
            if (filter.location === ALL_FILTER) {
                return setFilter(views.agencies, [user.agencyId], groups.agents);
            }
            return setFilter(views.locations, [filter.location], groups.agents);
        case cardTypes.overviewAgentWords:
            return setFilter(views.agent, [user.id], groups.agents);

        case cardTypes.locationAgentsWords:
        case cardTypes.locationAgentsSpeechRatio:
            if (filter.team === TEAM_FILTER.myLocation) {
                return setFilter(views.team, selectTeamIds(entities), groups.agents);
            }
            return setFilter(views.teams, [filter.team], groups.agents);

        case cardTypes.overviewLocationTeamsWords:
            if (filter.team && filter.team !== TEAM_FILTER.myLocation) {
                return setFilter(views.teams, [filter.team], groups.team);
            }
            if (dashboardSelections.itemType === views.agents) {
                return setFilter(views.agents, dashboardSelections.itemsList, groups.agents);
            }
            if (dashboardSelections.itemType === views.teams) {
                return setFilter(views.teams, dashboardSelections.itemsList, groups.team);
            }

            if (dashboardSelections.itemType === views.team) {
                return setFilter(views.teams, dashboardSelections.itemsList, groups.team);
            }
            return setFilter(views.team, selectTeamIds(entities), groups.team);
        case cardTypes.locationTeamsSpeechRatio: {
            return setFilter(views.team, selectTeamIds(entities), groups.team);
        }

        default:
            return setFilter(views.all, [], groups.all);
    }
};
